import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function tablasReducer(state= initialState.tablas, action){
	let newState;
	switch(action.type){
        
        case types.UPDATE_TABLA:
            newState=Object.assign([], state);
            newState=[...newState.filter(tabla => tabla.nombre !== action.tabla.nombre)];
            newState.push(action.tabla);
            return newState;
            
		default:
			return state;
	}
}